import {useTileAnimation, type TileProps} from './types'

export const Tile1 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'rect',
    scaleProperty: 'scaleX',
    transformOrigin: '0% 50%',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <rect width="400" height="155" transform="matrix(-1 0 0 1 400 -3.55859)" fill={colors[0]} />
      <rect x="-34" y="116.441" width="120" height="40" fill={colors[1]} />
      <rect x="26" y="76.4414" width="121" height="40" fill={colors[1]} />
      <rect x="81" y="36.4414" width="121" height="40" fill={colors[1]} />
      <rect x="141" y="-3.55859" width="120" height="40" fill={colors[1]} />
      <rect x="179" y="119.441" width="113" height="40" fill={colors[1]} />
      <rect x="233" y="79.4414" width="119" height="40" fill={colors[1]} />
      <rect x="287" y="39.4414" width="113" height="40" fill={colors[1]} />
    </svg>
  )
}
